import { defineMessages } from 'react-intl';

export const scope = 'app.components.FormikTimezoneSelect';

export default defineMessages({
  timeZoneLabel: {
    id: `${scope}.timeZoneLabel`,
    defaultMessage: 'Timezone',
  },
});
